import script from "./BootstrapPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./BootstrapPagination.vue?vue&type=script&setup=true&lang=js"

import "./BootstrapPagination.vue?vue&type=style&index=0&id=2cc36424&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc36424"]])

export default __exports__